import { toURLSearchParams } from '@wix/sdk-runtime/rest-modules';
import { resolveUrl } from '@wix/sdk-runtime/rest-modules';
import { ResolveUrlOpts } from '@wix/sdk-runtime/rest-modules';
import { RequestOptionsFactory } from '@wix/sdk-types';

function resolveWixPromoteSeoHeadlessSitemapServiceV1SeoHeadlessSitemapServiceUrl(
  opts: Omit<ResolveUrlOpts, 'domainToMappings'>
) {
  const domainToMappings = {
    'manage._base_domain_': [
      {
        srcPath: '/_api/seo-headless-sitemap/v1/list-static-sitemap-pages',
        destPath: '/v1/list-static-sitemap-pages',
      },
    ],
    _: [
      {
        srcPath: '/_api/seo-headless-sitemap/v1/list-sitemap-pages',
        destPath: '/v1/list-sitemap-pages',
      },
    ],
    '*.dev.wix-code.com': [
      {
        srcPath: '/_api/seo-headless-sitemap/v1/list-sitemap-pages',
        destPath: '/v1/list-sitemap-pages',
      },
    ],
    'www.wixapis.com': [
      {
        srcPath: '/v1/list-sitemap-pages',
        destPath: '/v1/list-sitemap-pages',
      },
    ],
    'api._api_base_domain_': [
      {
        srcPath: '/seo-headless-sitemap',
        destPath: '',
      },
    ],
  };

  return resolveUrl(Object.assign(opts, { domainToMappings }));
}

const PACKAGE_NAME = '@wix/auto_sdk_seo_seo-sitemap-entries';

/**
 * Lists sitemap pages for a given item type with optional pagination.
 * `item_type` only covers dynamic, repeater-generated items (Stores products, Blog posts,
 * Bookings services, etc. - see ItemType). It does NOT cover a site's static/main pages
 * (e.g. classic Editor "Home", "About", "Contact" pages) - those aren't represented by any
 * ItemType value and are never returned here, even for a fully published site. An empty or
 * partial `pages` result for a given itemType is not a signal that the site's static pages
 * are missing or unpublished.
 * This method is intended for headless sites, which fetch these entries to build and serve
 * their own sitemap.xml. Classic Editor/Studio sites don't need it - Wix generates and serves
 * their sitemap.xml for them. Note that the method does not detect or reject a site's editor
 * type; it reads the site's live Site Structure either way. So it is not a way to distinguish
 * headless from classic sites, and it is not the right tool for diagnosing a classic site's
 * auto-generated sitemap - inspect the sitemap XML served on that site's own domain instead.
 *
 * Returns NOT_FOUND when the site is not indexable or is not published.
 */
export function listSitemapPages(payload: object): RequestOptionsFactory<any> {
  function __listSitemapPages({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.promote.seo.v1.headless_sitemap_entry',
      method: 'GET' as any,
      methodFqn:
        'wix.promote.seo.headless.sitemap.service.v1.SeoHeadlessSitemapService.ListSitemapPages',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveWixPromoteSeoHeadlessSitemapServiceV1SeoHeadlessSitemapServiceUrl(
        { protoPath: '/v1/list-sitemap-pages', data: payload, host }
      ),
      params: toURLSearchParams(payload),
    };

    return metadata;
  }

  return __listSitemapPages;
}
